import { tipoVolume } from './service';
import { Form, Select } from 'antd';
import Swal from 'sweetalert2';
import { useEffect, useState } from 'react';
import { Props } from './props';

const SelectTipoVolume = ({ setTipoVolume, setRequired, setName, label, disabled }: Props) => {
  const { Option } = Select;
  const [volumes, setVolumes] = useState([]);

  async function handleChange(value: string) {
    setTipoVolume?.(value);
  }

  useEffect(() => {
    try {
      tipoVolume.getVolumes().then((res) => {
        setVolumes(res.data.volumes);
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar os tipos de volumes, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }, []);

  return (
    <Form.Item
      label={label ? label : ''}
      name={setName}
      rules={[{ required: setRequired, message: 'Digitar o tipo do volume' }]}
    >
      <Select
        disabled={disabled ?? false}
        placeholder="Selecione o tipo do volume"
        style={{ width: '100%' }}
        onChange={handleChange}
        filterOption={(inputValue, element) =>
          element?.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        showSearch
      >
        {volumes?.map((item: any) => (
          <Option value={item.cod}>{item.descricao}</Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectTipoVolume;
